const airline = (state) => state.airline
const lang = (state) => state.lang
const pax = (state) => state.pax
const title = (state) => state.title
const interCmtId = (state) => state.internalCmtId
const paxsGroup = (state) => state.paxsGroup
const isConfirmYet = (state) => state.isConfirmYet
const isInfoFlightPage = (state) => state.isInfoFlightPage
const paxBoarding = (state) => state.paxBoarding
const validGGApi = (state) => state.validGGApi
const direction = (state) => state.direction
export default {
  airline,
  lang,
  pax,
  title,
  interCmtId,
  paxsGroup,
  isConfirmYet,
  isInfoFlightPage,
  paxBoarding,
  validGGApi,
  direction
}
